/**
 * wishlist.js
 * Datei: assets/wishlist.js
 * Merkliste via localStorage – Pipeline Theme
 */

/* ── i18n (window.EG_I18N wird in layout/theme.liquid gesetzt) ── */
const EG_T = (k, fb) => (window.EG_I18N && window.EG_I18N[k]) || fb;

/* ── Hilfen: Fehlermeldung im Drawer + Proben-Erkennung (wie product-grid-item.liquid) ── */
const WL_MSG = {
  show(text, type) {
    const el = document.getElementById('wl-msg');
    if (!el) return;
    el.textContent = text;
    el.className = 'wl-msg' + (type ? ' wl-msg--' + type : '');
    el.style.display = 'block';
  },
  hide() {
    const el = document.getElementById('wl-msg');
    if (el) { el.textContent = ''; el.style.display = 'none'; }
  }
};
/* Probe = SKU mit ABF- ODER ein Optionswert, der genau eine Proben-Größe ist (≤ 3 ml, z. B. "3 ml", "3 ml (Abfüllung)").
   Travel-Size (6 ml, SKU TRA-) und Flakons sind KEINE Proben. Kein Fallback. */
const WL_SAMPLE_RE = /^\s*(\d+(?:[.,]\d+)?)\s?ml\s*(?:\((?:abfüllung|probe|sample)\))?\s*$/i;
const WL_isSample = v => {
  if ((v.sku || '').toUpperCase().startsWith('ABF-')) return true;
  const opts = (v.options && v.options.length ? v.options : [v.option1, v.option2, v.option3]).filter(Boolean);
  return opts.some(o => {
    const m = String(o).match(WL_SAMPLE_RE);
    return m && parseFloat(m[1].replace(',', '.')) <= 3;
  });
};
const WL_handle = url => {
  const m = String(url || '').match(/\/products\/([^/?#]+)/);
  return m ? decodeURIComponent(m[1]) : null;
};
/* Frische Produktdaten beim Klick (nicht die beim Merken gespeicherten) */
const WL_fetchProduct = p => {
  const h = WL_handle(p.url);
  if (!h) return Promise.resolve(null);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
    .then(r => (r.ok ? r.json() : null)).catch(() => null);
};
const WL_findSample = product => {
  if (!product || !product.variants) return null;
  return product.variants.find(v => v.available && WL_isSample(v)) || null;
};
/* Theme-Warenkorb wie im Theme selbst aktualisieren (product-form handleSuccess):
   /cart.js holen -> theme:cart:change MIT detail.cart -> Drawer öffnen bzw. neu laden */
const WL_refreshThemeCart = () => {
  const root = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
  return fetch(root + '.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(cart => {
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
      if (window.theme && window.theme.state && window.theme.state.cartOpen) {
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        return;
      }
      const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (cartDrawer) cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
      else {
        const t = document.querySelector('[data-drawer-toggle="drawer-cart"]');
        if (t) t.click();
      }
    })
    .catch(() => {});
};
/* Antwort von /cart/add.js prüfen: Shopify liefert bei Fehlern status 4xx + description */
const WL_cartAdd = body => fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  body: JSON.stringify(body)
}).then(r => r.json().catch(() => ({})).then(data => {
  if (!r.ok || data.status) {
    throw new Error(data.description || data.message || 'Der Artikel konnte nicht in den Warenkorb gelegt werden.');
  }
  return data;
}));

/* ── Storage ── */
const WishlistStore = {
  KEY: 'pipeline_wishlist',
  get() {
    try { return JSON.parse(localStorage.getItem(this.KEY)) || []; }
    catch { return []; }
  },
  set(items) {
    localStorage.setItem(this.KEY, JSON.stringify(items));
  },
  has(id) {
    return this.get().some(p => p.id == id);
  },
  add(product) {
    const items = this.get();
    if (!this.has(product.id)) { items.push(product); this.set(items); }
  },
  remove(id) {
    this.set(this.get().filter(p => p.id != id));
  },
  count() {
    return this.get().length;
  }
};

/* ── Core Wishlist API ── */
const Wishlist = window.Wishlist = {
  toggle(btn) {
    if (!btn) return;
    const id = btn.dataset.productId;
    if (!id) return;
    if (WishlistStore.has(id)) {
      WishlistStore.remove(id);
    } else {
      let variants = [];
      try { variants = JSON.parse(btn.dataset.productVariants || '[]'); } catch(e) {}
      WishlistStore.add({
        id:        btn.dataset.productId,
        title:     btn.dataset.productTitle,
        vendor:    btn.dataset.productVendor,
        price:     btn.dataset.productPrice,
        url:       btn.dataset.productUrl,
        image:     btn.dataset.productImage,
        variants:  variants
      });
    }
    this.syncButtons();
    WishlistDrawer.render();
    WishlistDrawer.updateBadge();
  },

  syncButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const active = WishlistStore.has(btn.dataset.productId);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? EG_T('wishlist_remove', 'Von Merkliste entfernen') : EG_T('wishlist_add', 'Zur Merkliste hinzufügen'));
    });
  }
};

/* ── Drawer ── */
const WishlistDrawer = window.WishlistDrawer = {
  open() {
    const drawer = document.getElementById('wl-drawer');
    if (!drawer) return;
    drawer.classList.add('wl-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => this.render(), 10);
  },

close() {
    const drawer = document.getElementById('wl-drawer');
    const panel = document.getElementById('wl-panel');
    if (!drawer) return;
    document.body.style.overflow = '';          // ← SOFORT freigeben, vor dem Cart-Handoff
    panel.style.animation = 'wlSlideOut 0.3s ease forwards';
    setTimeout(() => {
      drawer.classList.remove('wl-open');
      drawer.setAttribute('aria-hidden', 'true');
      panel.style.animation = '';
    }, 300);
  },

  updateBadge() {
    const count = WishlistStore.count();
    document.querySelectorAll('[data-wishlist-badge]').forEach(el => {
      if (!el) return;
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  render() {
    const items    = WishlistStore.get();
    const list     = document.getElementById('wishlist-items-list');
    const empty    = document.getElementById('wishlist-empty-state');
    const footer   = document.getElementById('wl-footer');
    const addAll   = document.getElementById('wl-add-all');

    // Add-All-Button immer in den Grundzustand zurücksetzen
    if (addAll) {
      addAll.disabled = false;
      addAll.textContent = EG_T('wishlist_add_all', 'Alle als Probe in den Warenkorb');
    }

    WL_MSG.hide();

    if (!list) { console.warn('Wishlist: #wishlist-items-list nicht gefunden'); return; }

    if (items.length === 0) {
      list.innerHTML  = '';
      if (empty)  empty.style.setProperty('display', 'block', 'important');
      // Links im leeren Zustand absichern (falls das Markup fehlt oder überschrieben wurde)
      if (empty && !empty.querySelector('.wl-empty-actions')) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const box = document.createElement('div');
        box.className = 'wl-empty-actions';
        box.innerHTML = '<a href="' + root + 'collections/abfullungen" class="wl-empty-btn wl-empty-btn--primary">Proben entdecken</a>'
                      + '<a href="' + root + 'pages/duftberater" class="wl-empty-btn">Zum Duftberater</a>';
        empty.appendChild(box);
      }
      if (footer) footer.style.setProperty('display', 'none', 'important');
      return;
    }
    if (empty)  empty.style.setProperty('display', 'none', 'important');
    if (footer) { footer.style.setProperty('display', 'flex', 'important'); footer.style.flexDirection = 'column'; }

    list.innerHTML = items.map(p => {
      const variants = p.variants || [];
      const variantButtons = variants.length > 1
        ? `<div class="wl-item__variants">
            ${variants.map(v => `
              <button class="wl-item__variant-btn${!v.available ? ' wl-item__variant-btn--sold' : ''}"
                onclick="WishlistDrawer.addToCart(this, '${v.id}')"
                ${!v.available ? 'disabled' : ''}
                title="${v.title}">
                ${v.title}
              </button>
            `).join('')}
           </div>`
        : variants.length === 1
          ? `<button class="wl-item__atc" onclick="WishlistDrawer.addToCart(this, '${variants[0].id}')">${EG_T('add_to_cart', 'In den Warenkorb')}</button>`
          : `<button class="wl-item__atc" onclick="WishlistDrawer.addToCart(this, '')">${EG_T('add_to_cart', 'In den Warenkorb')}</button>`;

      return `
      <div class="wl-item" data-wishlist-item="${p.id}">
        <div class="wl-item__img-wrap">
          <a href="${p.url}" class="wl-item__img">
            <img src="${p.image}" alt="${p.title}" loading="lazy">
          </a>
          <button class="wl-item__remove-badge"
            onclick="WishlistDrawer.removeItem('${p.id}')"
            aria-label="${EG_T('remove', 'Entfernen')}">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div class="wl-item__info">
          ${p.vendor ? `<div class="wl-item__vendor">${p.vendor}</div>` : ''}
          <a href="${p.url}" class="wl-item__title">${p.title}</a>
          <div class="wl-item__bottom">${variantButtons}</div>
        </div>
      </div>
    `}).join('');
  },

  removeItem(id) {
    WishlistStore.remove(id);
    Wishlist.syncButtons();
    this.render();
    this.updateBadge();
  },

  clearAll() {
    WishlistStore.set([]);
    Wishlist.syncButtons();
    this.render();
    this.updateBadge();
  },

  addAllSamples() {
    const items = WishlistStore.get();
    if (!items.length) return;

    const btn = document.getElementById('wl-add-all');
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    const resetBtn = () => {
      if (btn) { btn.disabled = false; btn.textContent = EG_T('wishlist_add_all', 'Alle als Probe in den Warenkorb'); }
    };

    // Frische Daten pro Duft holen; nur echte Proben, KEIN Fallback auf Flakons
    Promise.all(items.map(WL_fetchProduct)).then(products => {
      let skipped = 0;
      const cartItems = [];
      products.forEach(prod => {
        const sample = WL_findSample(prod);
        if (sample) cartItems.push({ id: sample.id, quantity: 1 });
        else skipped++;
      });
      const skippedText = skipped
        ? (skipped === 1 ? '1 Duft ohne verfügbare Probe übersprungen' : skipped + ' Düfte ohne verfügbare Probe übersprungen')
        : '';

      if (!cartItems.length) {
        resetBtn();
        WL_MSG.show('Keiner deiner gemerkten Düfte hat gerade eine verfügbare Probe.', 'error');
        return;
      }

      return WL_cartAdd({ items: cartItems }).then(() => {
        if (btn) btn.textContent = EG_T('added', '✓ Hinzugefügt');
        if (skippedText) {
          // Hinweis zeigen, Drawer offen lassen; Header-Zähler trotzdem aktualisieren
          WL_MSG.show('✓ Proben hinzugefügt. ' + skippedText + '.', 'info');
          const root = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
          fetch(root + '.js').then(r => r.json()).then(cart => {
            document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
          }).catch(() => {});
          setTimeout(resetBtn, 1500);
          return;
        }
        setTimeout(() => {
          resetBtn();
          this.close();
          WL_refreshThemeCart();
        }, 500);
      }).catch(err => {
        resetBtn();
        WL_MSG.show(err.message + (skippedText ? ' (' + skippedText + ')' : ''), 'error');
      });
    });
  },

  addToCart(btn, variantId) {
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    WL_MSG.hide();
    WL_cartAdd({ id: variantId, quantity: 1 })
    .then(() => {
      btn.textContent = EG_T('added', '✓ Hinzugefügt');
      setTimeout(() => {
        this.close();
        WL_refreshThemeCart();
      }, 500);
    })
    .catch(err => {
      btn.disabled = false;
      btn.textContent = label;
      WL_MSG.show(err.message, 'error');
    });
  }
};
/* ── Init ── */
document.addEventListener('DOMContentLoaded', () => {
  Wishlist.syncButtons();
  WishlistDrawer.updateBadge();

  // Direkt auf die Wishlist-Buttons binden
  ['wishlist-open-desktop', 'wishlist-open-mobile'].forEach(id => {
    const btn = document.getElementById(id);
    if (btn) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        WishlistDrawer.open();
      });
    }
  });
});